// extracted by mini-css-extract-plugin
module.exports = {"body":"PaymentData_body__taSS-","infoContainer":"PaymentData_infoContainer__2dYIT","icon":"PaymentData_icon__9Qu94"};